<jqxGrid
width="100%" height="100%" [source]="data" [theme]="gridTheme" [pageable]="false" [altrows]="true"
[editable]="true" [localization]="config.localization" [enabletooltips]="false"
[selectionmode]="config.selectionType" [enablebrowserselection]="true"
[showrowlines]="false" [rowsheight]="30" [filterrowheight]="20" [showfilterrow]="false"
[filterable]="true" [filter]="config.filterType" [updatefilterconditions]="config.updateFilterConditions"
[showaggregates]="true" [showstatusbar]="true" [statusbarheight]="20"
[columns]="columns" [columnsresize]="true" [columnsheight]="25" [showcolumnlines]="true"
[columnmenuopening]="config.columnOpening" [columngroups]="config.columnGroups"
[showtoolbar]="config.showToolbar" [rendertoolbar]="config.toolbar" [toolbarheight]="30"
[sortable]="true" [sortmode]="config.sortMode" [cellhover]="config.cellHover"
[groupable]="config.isGroupable" [groupsrenderer]="config.groupsRenderer"
[showgroupsheader]="config.showGroupsHeader" [groupsheaderheight]="20"
[contextmenuitems]="config.contextMenuItems" [contextmenuitemclick]="config.contextMenuItemClick"
[contextmenuenabled]="config.contextMenuEnabled"
(onRowclick)="handleRowClick($event)" (onRowselect)="handleRowSelect($event)" (onRowunselect)="handleRowUnselect($event)"
(onRowdoubleclick)="handleRowDoubleClick($event)" (onBindingcomplete)="emitGridRendered()" (onSort)="handleSort($event)"
(onFilter)="handleFilter($event)"
#grid>
</jqxGrid>
